<!--Footer Starts-->
<footer class="footer">
  <p class="copyright clearfix text-muted m-0">
    {{'Copyright' | translate}} &copy; {{currentDate | date: 'yyyy'}}
    <span class="d-none d-sm-inline-block">, {{'All rights reserved.' | translate}}</span>
  </p>
</footer>
<!--Footer Ends-->
